import { apiCall } from "./Interceptor";

const CONTROL_AREA_ALL = "/controlArea/getAll/public";

const getAllControlArea = async () => {
    const response = await apiCall.get(CONTROL_AREA_ALL);
    return response;
}

export default {
    getAllControlArea,
};
